module.exports = __webpack_public_path__ + "img/unrevealed4.66e15c45.svg";